<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="600" persistent>
    <div class="dialog-header-container d-flex align-center">
      <div class="dialog-header-text">{{$t('menuLayout.dialog.correction')}}</div>
      <div class="dialog-header-btn" @click="$emit('closeDialog')">
        <v-icon class="pl-1" size="24" color="white">md mdi-close</v-icon>
      </div>
    </div>
    <v-card class="dialog-card">
      <div class="px-4 pt-2 d-flex">
        <div class="dialog-text pr-5">
          {{$t('menuLayout.dialog.name')}}
        </div>
          <input :value="caption" @input="changeCaption($event.target.value)" class="dialog-input"/>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="$emit('renameFunctionMenu', newCaption)"
        >
          {{$t('menuLayout.dialog.save')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'caption'],
  data: () => ({
    newCaption: ''
  }),
  methods: {
    changeCaption(value) {
      this.newCaption = value
    }
  }
}
</script>